import { AutocompleteEditor } from "../../editors/autocompleteEditor/index.mjs";
import { autocompleteRenderer } from "../../renderers/autocompleteRenderer/index.mjs";
import { autocompleteValidator } from "../../validators/autocompleteValidator/index.mjs";
export var CELL_TYPE = 'autocomplete';
export var AutocompleteCellType = {
  CELL_TYPE: CELL_TYPE,
  editor: AutocompleteEditor,
  renderer: autocompleteRenderer,
  validator: autocompleteValidator
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_handsontable@8.4.0@handsontable/cellTypes/autocompleteType/autocompleteType.mjs
// module id = null
// module chunks = 